import { render, staticRenderFns } from "./DayRedpack2.vue?vue&type=template&id=4db89b0a&scoped=true&"
import script from "./DayRedpack2.vue?vue&type=script&lang=js&"
export * from "./DayRedpack2.vue?vue&type=script&lang=js&"
import style0 from "./DayRedpack2.vue?vue&type=style&index=0&id=4db89b0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db89b0a",
  null
  
)

export default component.exports